import React from 'react'

import clsx from 'clsx'

import classes from './Grid.module.scss'

/** @type {import("./types").default} */
const Grid = ({ children }) => {
  return <div className={clsx('Grid', classes.root)}>{children}</div>
}

export default Grid
